// menu-items/dashboard.js
/* eslint-disable */
import { FormattedMessage } from 'react-intl';
import {
    IconDashboard,
    IconRoute,
    IconClipboardList,
    IconReportAnalytics,
    IconUser,
    IconSettings,
    IconHome,
    IconUserCircle,
    IconUsers,
    IconCalendarEvent,
    IconSteeringWheel
} from '@tabler/icons';

const icons = {
    IconDashboard,
    IconRoute,
    IconClipboardList,
    IconReportAnalytics,
    IconUser,
    IconSettings,
    IconHome,
    IconUserCircle,
    IconUsers,
    IconCalendarEvent,
    IconSteeringWheel
};

const dashboard = {
    id: 'dashboard',
    title: <FormattedMessage id="dashboard" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'home',
            title: <FormattedMessage id="home" />,
            type: 'item',
            url: '/dashboard/default',
            icon: icons.IconHome,
            breadcrumbs: false,
            roles: ['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_ACCOUNTANT', 'ROLE_SUPERUSER']
        },
        {
            id: 'myTrips',
            title: <FormattedMessage id="myTrips" />,
            type: 'item',
            url: '/dashboard/my-trips',
            icon: icons.IconRoute,
            breadcrumbs: false,
            roles: ['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_SUPERUSER']
        },
        {
            id: 'tripAdminSupervisor',
            title: <FormattedMessage id="tripAdminSupervisor" />,
            type: 'item',
            url: '/dashboard/trips-adminstration-s',
            icon: icons.IconClipboardList,
            breadcrumbs: false,
            roles: ['ROLE_SUPERVISOR', 'ROLE_SUPERUSER']
        },
        {
            id: 'tripAdminFinance',
            title: <FormattedMessage id="tripAdminFinance" />,
            type: 'item',
            url: '/dashboard/trips-adminstration-f',
            icon: icons.IconClipboardList,
            breadcrumbs: false,
            roles: ['ROLE_FINANCE', 'ROLE_SUPERUSER']
        },
        {
            id: 'tripAdminHOD',
            title: <FormattedMessage id="tripAdminHOD" />,
            type: 'item',
            url: '/dashboard/trips-adminstration-h',
            icon: icons.IconClipboardList,
            breadcrumbs: false,
            roles: ['ROLE_HOD', 'ROLE_SUPERUSER']
        },
        {
            id: 'upcomingTrips',
            title: <FormattedMessage id="upcomingTrips" />,
            type: 'item',
            url: '/dashboard/upcoming-trips',
            icon: icons.IconCalendarEvent,
            breadcrumbs: false,
            roles: ['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_SUPERUSER','ROLE_ADMIN_OFFICER']
        },
        // {
        //     id: 'drivers',
        //     title: <FormattedMessage id="drivers" />,
        //     type: 'item',
        //     url: '/dashboard/drivers',
        //     icon: icons.IconSteeringWheel,
        //     breadcrumbs: false,
        //     roles: ['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE']
        // },
        // {
        //     id: 'defaultAdmin',
        //     title: <FormattedMessage id="defaultAdmin" />,
        //     type: 'item',
        //     url: '/dashboard/default-admin',
        //     icon: icons.IconUserCircle,
        //     breadcrumbs: false,
        //     roles: ['ROLE_SUPERVISOR', 'ROLE_HOD']
        // },
        {
            id: 'reports',
            title: <FormattedMessage id="reports" />,
            type: 'item',
            url: '/dashboard/reports',
            icon: icons.IconReportAnalytics,
            breadcrumbs: false,
            roles: ['ROLE_FINANCE', 'ROLE_ACCOUNTANT', 'ROLE_SUPERUSER','ROLE_AUDITOR']
        },
        {
            id: 'profile',
            title: <FormattedMessage id="profile" />,
            type: 'item',
            url: '/ui',
            icon: icons.IconUser,
            breadcrumbs: false,
            roles: ['ROLE_ACCOUNTANT', 'ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_FINANCE', 'ROLE_SUPERUSER']
        },
        {
            id: 'admin-portal',
            title: <FormattedMessage id="admin-portal" />,
            type: 'item',
            url: '/admin-portal',
            icon: icons.IconUsers,
            breadcrumbs: false,
            roles: ['ROLE_ADMIN', 'ROLE_SUPERUSER', 'ROLE_SUPERVISOR']
        },
        {
            id: 'accountOfficer',
            title: <FormattedMessage id="accountOfficer" />,
            type: 'collapse',
            icon: icons.IconUsers,
            roles: ['ROLE_FINANCE', 'ROLE_ACCOUNTANT', 'ROLE_SUPERUSER'],
            children: [
                {
                    id: 'financeOfficerRequests',
                    title: <FormattedMessage id="financeOfficerRequests" />,
                    type: 'item',
                    url: '/finance-officer/requests',
                    breadcrumbs: false,
                    roles: ['ROLE_FINANCE', 'ROLE_ACCOUNTANT', 'ROLE_SUPERUSER']
                },
                {
                    id: 'financeOfficerAcquittals',
                    title: <FormattedMessage id="financeOfficerAcquittals" />,
                    type: 'item',
                    url: '/finance-officer/acquittals',
                    breadcrumbs: false,
                    roles: ['ROLE_ACCOUNTANT', 'ROLE_FINANCE', 'ROLE_SUPERUSER']
                }
            ]
        }
    ]
};

export default dashboard;
